export const PLAYER_CSS_CLASSNAME = '__remotion-player';
